import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { browserClient } from './js/react-query';

const __COMMIT_HASH__ = process.env.REACT_APP_COMMIT_HASH;

export const sentry = initSentry();

function initSentry() {
    const client = new Sentry.BrowserClient({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        enabled: getEnvironment() !== 'development',
        environment: getEnvironment(),
        release: __COMMIT_HASH__,
        transport: Sentry.makeFetchTransport,
        stackParser: Sentry.defaultStackParser,
        integrations: [
            ...Sentry.getDefaultIntegrations({}),
            Sentry.extraErrorDataIntegration(),
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes
            }),
            {
                name: 'ReactQuery',
                setupOnce() {
                    browserClient.getQueryCache().subscribe(() => {
                        const state = browserClient
                            .getQueryCache()
                            .getAll()
                            .map(query => ({
                                queryHash: query.queryHash,
                                queryKey: query.queryKey,
                                state: query.state.status
                            }));
                        Sentry.setContext('reactQuery', { queries: state });
                    });
                }
            }
        ]
    });
    const scope = new Sentry.Scope();
    scope.setClient(client);
    client.init();
    return client;
}

function getEnvironment() {
    switch (window.location.hostname) {
        case 'connect.borrowbox.com':
            return 'production';
        case 'connect-stage.borrowbox.io':
            return 'stage';
        case 'connect-demo.borrowbox.com':
            return 'demo';
        default:
            return 'development';
    }
}
